<template>
    <!-- <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="row">
          <div class="col-md-4 mb-20">
            <div class="form-group">
              <label>Zone:</label>
              <v-select
                class="custom-select-height"
                label="name"
                :options="ZonesList"
                v-model="zone_filter"
                @input="fetchLivs(zone_filter)"
              />
            </div>
          </div>
          <div class="col-md-4 mb-20">
            <div class="form-group">
              <label>Livreur :</label>
              <v-select
                class="custom-select-height"
                label="name"
                :options="LivreursList"
                v-model="liv_filter"
              >
              </v-select>
            </div>
          </div>
          <div class="col-md-4 mb-20">
            <div class="form-group">
              <label>Statut:</label>
              <select
                class="custom-select-height form-control"
                v-model="status_filter"
              >
                <option value="" selected>Status (Tous)</option>
                <option :value="0" selected>Nouveau</option>
                <option :value="1" selected>Enregistré</option>
                <option :value="2">Payé</option>
              </select>
            </div>
          </div>

          <div class="col-md-4 mb-20">
            <div class="form-group">
              <label>Par Date :</label>
             <rangedate-picker ref="myInput" v-model="date_filter" format="YYYY-MM-DD" i18n="EN"
                  :presetRanges="presetRanges" :captions="captions"></rangedate-picker>
            </div>
          </div>
          <div class="col-md-4 mb-20">
            <div class="form-group">
              <label>Créer par:</label>
              <v-select
                class="custom-select-height"
                v-model="created_filter"
                label="name"
                :options="CuserList"
                @search="onSearchUsers"
              >
              </v-select>
            </div>
          </div>
           <div class="col-md-4">
              <div class="form-group">
                <label>Chercher :</label>
                <input 
                  v-model="searchTerm"
                  class="form-control"
                  placeholder="Chercher">
                </input>
              </div>
            </div>
          <div class="col-md-4 mb-20">
            <button
              style="margin-top: 22px"
              class="btn btn-primary"
              @click="filter()"
            >
              <i class="flaticon-search" style="margin-right: 5px"></i>
              Filtrer
            </button>
            <button
              style="margin-top: 22px"
              class="btn btn-danger"
              @click="Removefilter()"
            >
              <i class="flaticon-close" style="margin-right: 5px"></i>
              Annuler
            </button>
          </div>
        </div>
      </div>
    </div> -->
    <div class="card mb-25 p-3 border-0 rounded-0 bg-white letter-spacing">
      <!-- <div class="row mb-20">
        <div class="col-md-6">
          <label>Voir</label>
          <v-select
            v-model="users.per_page"
            :options="[10, 25, 50, 100]"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
            @update:modelValue="getRecords()"
          />
          <label>sur {{ users.total }} entités</label>
        </div>

        <div class="col-md-12">
          <div class="d-flex align-items-center justify-content-end">
            <input
              v-model="searchTerm"
              class="form-control"
              @change="filter()"
              placeholder="Chercher"
              @input="handleInput"
            />
          </div>
        </div>
      </div> -->

      <div class="col-md-12 mb-20 p-3">
        <!-- <button
          v-if="auth.can('ADD_BP_Z')"
          @click="AutoAdd"
          class="btn btn-success"
          style="margin-right: 12px"
        >
          <span class="text-nowrap"> Auto-Ajout Bon pour Zone</span>
         
        </button> -->
        <router-link
          class="btn btn-primary"
          v-if="auth.can('ADD_BP_Z')"
          :to="{ name: 'NewPaymentZonePage' }"
          style="margin-right: 12px"
        >
          Ajouter Bon pour Zone
        </router-link>
      </div>
      <br />

      <vue-good-table
        :columns="columns"
        :rows="rows"
        responsive
        
        :select-options="{
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Bons Sélectionés',
          disableSelectInfo: true,
        }"
        @on-selected-rows-change="selectPays"
        @on-select-all="onSelectAllPays"
      >
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template #table-row="props">
          <span v-if="props.column.field === 'pay_z_ref'" class="text-nowrap">
            <b>{{ props.row.pay_z_ref }}</b>
          </span>

          <span
            v-else-if="props.column.field === 'zone_name'"
            class="text-nowrap"
          >
            {{ props.row.zone_name }}<br />
            {{ props.row.agency_name }}
          </span>

          <span
            v-else-if="props.column.field === 'created_at'"
            class="text-nowrap"
          >
            <template v-if="props.row.created_at != null">
              {{ getDate(props.row.created_at) }}<br />
            </template>
            {{ props.row.by_name }}
          </span>

          <span
            v-else-if="props.column.field === 'paid_time'"
            class="text-nowrap"
          >
            <template v-if="props.row.paid_time != null">
              {{ getDate(props.row.paid_time) }}<br />
            </template>
            {{ props.row.paid_by_name }}
          </span>

          <span v-else-if="props.column.field === 'total'" class="text-nowrap">
            {{ props.row.total }} {{ $devis }}
          </span>

          <template v-else-if="props.column.field === 'statut'">
            <span
              v-if="props.row.statut == 0"
              class="badge rounded-pill fs-13 text-bg-danger"
            >
              Nouveau
            </span>
            <span
              v-else-if="props.row.statut == 1"
              class="badge rounded-pill fs-13 text-bg-info"
            >
              Enregistré
            </span>
            <span
              v-else-if="props.row.statut == 2"
              class="badge rounded-pill fs-13 text-bg-success"
            >
              Payé
            </span>
          </template>
          <template v-else-if="props.column.field === 'action'">
            <div class="dropdown">
              <button
                class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <li>
                  <router-link
                    class="dropdown-item"
                    :to="{
                      path: `/edit_payments_zone/${props.row.id}/${props.row.pay_z_ref}`,
                    }"
                  >
                    <i
                      class="flaticon-view lh-1 me-8 position-relative top-1"
                    ></i>
                    Détails
                  </router-link>
                </li>
                <li
                  v-if="
                    props.row.statut == 0 &&
                    props.row.num_bns == 0 &&
                    auth.can('BP_Z')
                  "
                >
                  <button class="dropdown-item" @click="RemoveNote(props.row)">
                    <i
                      class="flaticon-delete lh-1 me-8 position-relative top-1"
                    ></i>
                    Supprimer
                  </button>
                </li>
                <li
                  v-if="
                    props.row.statut == 0 &&
                    props.row.num_bns != 0 &&
                    auth.can('BP_Z')
                  "
                >
                  <button class="dropdown-item" @click="SaveBon(props.row)">
                    <i
                      class="flaticon-diskette lh-1 me-8 position-relative top-1"
                    ></i>
                    Enregistrer
                  </button>
                </li>
                <li
                  v-if="
                    props.row.statut == 1 &&
                    props.row.num_bns != 0 &&
                    auth.can('BP_Z')
                  "
                >
                  <button class="dropdown-item" @click="OpenBon(props.row)">
                    <i
                      class="flaticon-unlock lh-1 me-8 position-relative top-1"
                    ></i>
                    Ouvrir
                  </button>
                </li>
                <li
                  v-if="
                    props.row.statut == 1 &&
                    props.row.num_bns != 0 &&
                    auth.can('BP_Z')
                  "
                >
                  <button class="dropdown-item" @click="BonPaid(props.row)">
                    <i
                      class="flaticon-check lh-1 me-8 position-relative top-1"
                    ></i>
                    Changer En Payé
                  </button>
                </li>
              </ul>
            </div>
          </template>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="users"
        :offset="9"
        @paginate="getRecords"
      />
      <!-- <div class="row mb-30" v-if="rows && rows.length != 0">
        <div class="col-md-12" style="margin-left: 15px">
          <button class="btn btn-success" @click="SaveNotes">
            Enregistrer
          </button>
          <button class="btn btn-info" @click="PaidNotes">Payer</button>
        </div>
      </div> -->
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ref, reactive } from "vue";
import { useAuthStore } from "@/stores/auth";
import moment from "moment";
import api from "@/utils/axios";
import { useAppToast } from "@/composables/useAppToast";
import router from "@/router";
import Swal from "sweetalert2";
import { onMounted } from "vue";
export default defineComponent({
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const isLoader = ref(false);
    const pageLength = ref(10);
    const loading = ref(false);
    const searchTerm = ref("");
    const columns = [
      {
        label: "Référence",
        field: "pay_z_ref",
      },
      {
        label: "Date de création",
        field: "created_at",
      },
      {
        label: "Date de paiement",
        field: "paid_time",
      },
      {
        label: "Zone",
        field: "zone_name",
      },
      {
        label: "Statut",
        field: "statut",
      },
      {
        label: "Bons",
        field: "num_bns",
      },
      {
        label: "Total",
        field: "total",
      },
      {
        label: "Actions",
        field: "action",
        width: "180px",
      },
    ];
    const rows = ref([]);
    const ZonesList = ref([]);
    const zone_filter = ref({ id: "", name: "" });
    const status_filter = ref("");
    const date_filter = ref("");
    const users = reactive({
      searchTerm: "",
      searchZone: "",
      searchStatut: "",
      searchSDate: "",
      searchEDate: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const offset = ref(9);
    const row_ref = ref({});
    const pricePaid = ref(0);
    const selectedRows = ref([]);

    const onSearchZones = async (
      search: string,
      loading: (val: boolean) => void
    ) => {
      if (search.length && ZonesList.value.length === 0) {
        loading(true);
        try {
          const response = await api.get(`/api/auth/ListZone`);
          ZonesList.value = response.data;
          ZonesList.value.unshift({ id: "", name: "Tous" });
        } finally {
          loading(false);
        }
      }
    };

    const getDate = (value: string) => {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    };

    const resolveUserStatusVariant = (status: number) => {
      if (status === 0) return "danger";
      if (status === 1) return "info";
      if (status === 2) return "success";
      return "warning";
    };

    const convert = (str: string) => {
      const date = new Date(str);
      const mnth = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    };

    const filter = () => {
      users.searchZone = zone_filter.value.id;
      users.searchStatut = status_filter.value;
      // users.searchSDate =
      // date_filter.value && date_filter.value.start
      //   ? convert(date_filter.value.start)
      //   : "";
      // users.searchEDate =
      // date_filter.value && date_filter.value.end
      //   ? convert(date_filter.value.end)
      //   : "";
      users.current_page = 1;
      getRecords();
    };

    const Removefilter = () => {
      users.searchZone = "";
      users.searchStatut = "";
      users.searchTerm = "";
      users.searchSDate = "";
      users.searchEDate = "";
      status_filter.value = "";
      date_filter.value = "";
      zone_filter.value = { id: "", name: "" };
      users.current_page = 1;
      // date_filter.value = {};
      getRecords();
    };

    let debounceTimer: any = null;
    const handleInput = () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        users.searchTerm = searchTerm.value;
        filter();
      }, 500);
    };

    const getRecords = async (page = 1) => {
      isLoader.value = true;
      users.current_page = page;
      try {
        const response = await api.get(
          `/api/auth/payment_zone_list?searchTerm=${users.searchTerm}&searchZone=${users.searchZone}&searchStatut=${users.searchStatut}&searchSDate=${users.searchSDate}&searchEDate=${users.searchEDate}&page=${users.current_page}&per_page=${users.per_page}`
        );
        rows.value = response.data.users.data;
        Object.assign(users, response.data.users);
      } finally {
        isLoader.value = false;
      }
    };

    const SaveBon = async (row: any) => {
      const result = await Swal.fire({
        text: "Vous voulez enregistrer ce bon ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, enregistrer!",
        cancelButtonText: "Annuler",
      });
      if (result.value) {
        try {
          const res = await api.post(`/api/auth/save_bp_zone/${row.id}`);
          if (res.data.message === "success") {
            filter();
          } else if (
            res.data.message === "not exist" ||
            res.data.message === "no parcel"
          ) {
            showToast("Vous pouvez pas enregistrer ce bon", "error");
          } else {
            showToast("Un erreur ! ", "error");
          }
        } catch {
          showToast("Something went wrong! Pleaz try again", "error");
        }
      }
    };

    const OpenBon = async (row: any) => {
      try {
        const res = await api.post(`/api/auth/unsave_bp_zone/${row.id}`);
        if (res.data.message === "success") {
          filter();
        } else if (
          res.data.message === "not exist" ||
          res.data.message === "no parcel"
        ) {
          showToast("Vous pouvez pas transformer ce bon", "error");
        } else {
          showToast;
        }
      } catch {
        showToast("Something went wrong! Pleaz try again", "error");
      }
    };

    const BonPaid = async (row: any) => {
      const data = new FormData();
      data.append("note_ref", row.pay_z_ref);
      data.append("note_id", row.id);
      data.append("user_id", user?.id);
      try {
        const res = await api.post(`/api/auth/Paid_bp_zone`, data);
        if (res.data.message === "success") {
          filter();
        } else if (
          res.data.message === "not exist" ||
          res.data.message === "no parcel"
        ) {
          showToast("Vous pouvez pas transformer ce bon", "error");
        } else {
          showToast("Un erreur ! ", "error");
        }
      } catch {
        showToast("Something went wrong! Pleaz try again", "error");
      }
    };

    const AutoAdd = async () => {
      try {
        const res = await api.post(`/api/auth/autoadd_bp_zone`);
        if (res.data.msg === "success") {
          showToast("Les bons sont bien ajoutés", "success");
          getRecords();
        } else if (res.data.msg === "empty") {
          showToast("Aucun bon de paiment (Livreur) à ajouter", "error");
        } else if (res.data.msg === "unauthorized") {
          showToast("Vous pouvez pas ajouter des bons", "error");
        } else {
          showToast("Un erreur ! ", "error");
        }
      } catch {
        showToast("Something went wrong! Pleaz try again", "error");
      }
    };

    const RemoveNote = async (row: any) => {
      const result = await Swal.fire({
        text: "Vous voulez supprimer le ce bon ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      });
      if (result.value) {
        try {
          const res = await api.post(`/api/auth/RemovePayZNote/${row.id}`);
          if (res.data.message === "success") {
            filter();
            showToast("Bon est bien supprimé", "success");
          } else if (res.data.message === "error") {
            showToast("Vous pouvez pas supprimer ce bon", "error");
          }
        } catch {
          showToast("Something went wrong! Pleaz try again", "error");
        }
      }
    };

    const selectPays = (params: any) => {
      selectedRows.value = params.selectedRows;
    };

    const onSelectAllPays = (params: any) => {
      selectedRows.value = params.selectedRows;
    };

    const SaveNotes = async () => {
      const notes: any[] = [];
      if (selectedRows.value.length > 0) {
        selectedRows.value.forEach((row: any) => {
          if (row.statut === 0 && row.num_bns !== 0) {
            notes.push({ id: row.id, ref: row.pay_z_ref });
          }
        });
        const result = await Swal.fire({
          text: "Vous voulez enregistrer ces bons ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui, enregistrer!",
          cancelButtonText: "Annuler",
        });
        if (result.value) {
          const data = new FormData();
          data.append("notes", JSON.stringify(notes));
          try {
            const res = await api.post(`/api/auth/save_all_paynote`, data);
            if (res.data === "success") {
              filter();
              showToast("Factures bien enregistrées", "success");
            } else if (res.data === "no note") {
              showToast("Vous pouvez pas les enregistrer", "error");
            }
          } catch {
            showToast("Something went wrong! Pleaz try again", "error");
          }
        }
      }
    };

    const PaidNotes = async () => {
      const notes: any[] = [];
      if (selectedRows.value.length > 0) {
        selectedRows.value.forEach((row: any) => {
          if (row.statut === 1 && row.num_bns !== 0) {
            notes.push({ id: row.id, ref: row.pay_z_ref });
          }
        });
        const result = await Swal.fire({
          text: "Vous voulez payer ces bons ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui, payer!",
          cancelButtonText: "Annuler",
        });
        if (result.value) {
          const data = new FormData();
          data.append("notes", JSON.stringify(notes));
          try {
            const res = await api.post(`/api/auth/paid_all_paynote`, data);
            if (res.data === "success") {
              filter();
              showToast("Factures bien enregistrées", "success");
            } else if (res.data === "no note") {
              showToast("Vous pouvez pas les enregistrer", "error");
            }
          } catch {
            showToast("Something went wrong! Please try again", "error");
          }
        }
      }
    };

    onMounted(async () => {
      getRecords();
      try {
        const response = await api.get("/api/auth/ListZone");
        if (response && response.data) {
          ZonesList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    });

    return {
      auth,
      user,
      isLoader,
      pageLength,
      loading,
      searchTerm,
      columns,
      rows,
      ZonesList,
      zone_filter,
      status_filter,
      date_filter,
      users,
      offset,
      row_ref,
      pricePaid,
      selectedRows,
      AutoAdd,
      onSearchZones,
      getDate,
      resolveUserStatusVariant,
      convert,
      filter,
      Removefilter,
      handleInput,
      getRecords,
      SaveBon,
      OpenBon,
      BonPaid,
      RemoveNote,
      selectPays,
      onSelectAllPays,
      SaveNotes,
      PaidNotes,
    };
  },
});
</script>
